import * as React from 'react';
import { LoadableContent, Page, PageNavigation } from '@ui/components';
import { connect } from 'react-redux';
import { StoreState } from '@ui/store/rootReducer';
import { collectionsSelectors } from '..';
import * as actions from '../services/actions';
import CollectionsLeftSide from './CollectionsLeftSide';
import CollectionCard from '../components/CollectionCard';

import './Collections.less';
import { metaSelectors } from '@ui/store/meta';

interface StateToProps {
  loading: boolean;
  collections: any[];
  countries: any[];
}

interface DispatchToProps {
  onLoadCollections: () => void;
  onRemoveCollection: (collectionId: string) => void;
  setEditCollection: (collection: any) => void;
}

type Props = StateToProps & DispatchToProps;

class Collections extends React.PureComponent<Props> {
  componentDidMount(): void {
    const { onLoadCollections } = this.props;

    onLoadCollections();
  }

  render() {
    const {
      loading,
      collections,
      onRemoveCollection,
      setEditCollection,
    } = this.props;

    return (
      <LoadableContent loading={loading}>
        <div className="collections-page">
          <PageNavigation title="Коллекции" />
          <Page>
            <Page.LeftSide>
              <CollectionsLeftSide />
            </Page.LeftSide>
            <Page.Content>
              <div className="collections-list">
                {[...collections]
                  .sort((a, b) => (a.name < b.name ? -1 : 1))
                  .map(collection => (
                    <CollectionCard
                      key={collection.id}
                      collection={collection}
                      removeCollection={onRemoveCollection}
                      onClickEdit={setEditCollection}
                    />
                  ))}
              </div>
            </Page.Content>
          </Page>
        </div>
      </LoadableContent>
    );
  }
}

const mapStateToProps = (state: StoreState): StateToProps => ({
  loading: collectionsSelectors.getLoading(state),
  collections: collectionsSelectors.getCollections(state),
  countries: metaSelectors.getCountries(state),
});

const mapDispatchToProps: DispatchToProps = {
  onLoadCollections: actions.collectionsRequested,
  onRemoveCollection: actions.removeCollectionRequested,
  setEditCollection: actions.setEditCollection,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Collections);



// WEBPACK FOOTER //
// ./src/scenes/Collections/containers/Collections.tsx